import { useRef } from "react";
import { prize, prizeType } from "../../../utils/timer";
import { MoneyInChip } from "../../tournament/hook/useEditTournament";

const TimerPrizeBox = ({
  data,
  item,
  index,
}: {
  data: any;
  item: MoneyInChip;
  index: number;
}) => {
  const boxRef = useRef<HTMLDivElement>(null);

  return (
    <div className="box" ref={boxRef}>
      <span>{prize(data, item, index)}</span> {prizeType(item)}
      {item.subPrize ? <div className="sub">{item.subPrize}</div> : ""}
    </div>
  );
};

export default TimerPrizeBox;
